module.exports = __webpack_public_path__ + "img/skills-bow-ama-2.c8840321.png";